import { createApp } from 'vue'
import App from './App.vue'
import '@/assets/scss/style.scss'
import { Amplify } from "aws-amplify";
import { getCognitoConfiguration } from '@training24/auth/customer';
import VueFeather from 'vue-feather';
import router from './router'
import { store, key } from './store'

//import awsconfig from "./aws-exports";
//Amplify.configure(awsconfig);

Amplify.configure({
    aws_cognito_username_attributes: [
        "EMAIL",
    ],
    aws_cognito_signup_attributes: [
        "EMAIL"
    ],
    Auth: {
        region: getCognitoConfiguration().CognitoRegion,
        userPoolId: getCognitoConfiguration().CognitoUserPoolId,
        userPoolWebClientId: getCognitoConfiguration().CognitoUserPoolClientId,
        clientMetadata: { platformName: 'MEDA FORTBILDUNGEN' },
        
        cookieStorage: {
            domain: window.location.hostname.split('.').slice(1).join('.') || window.location.hostname,
            secure: false,
            path: '/',
            expires: 5,
        },
        oauth: {
            domain: `${getCognitoConfiguration().CognitoUserPoolDomain}.auth.${getCognitoConfiguration().CognitoRegion}.amazoncognito.com`,
            scope: ['email', 'openid'],
            redirectSignIn: location.origin,
            redirectSignOut: `${location.origin}#logout`,
            responseType: 'code'
        }
    }
});

createApp(App)
    .use(store, key)
    .use(router)
    .component(VueFeather.name, VueFeather)
    .mount('#app')
import "bootstrap/dist/js/bootstrap.js"